import { useEffect } from "react";
import { t } from "i18next";
import { useDispatch, useSelector } from "react-redux";

import WPHeading from "@components/WPHeading";

import { clearRateLimit } from "@common/ApiSlice";
import CircularLoader from "@common/styles/components/circularLoader";

import "./WPRateLimitOverlay.scss";

export const WPRateLimitOverlay = () => {
  const dispatch = useDispatch();
  const rateLimitExpiry = useSelector(state => state.apiData.rateLimitExpiry);
  const isRateLimited = rateLimitExpiry > Date.now();

  useEffect(() => {
    if (!isRateLimited) return undefined;

    const timeoutId = setTimeout(
      () => dispatch(clearRateLimit(rateLimitExpiry)),
      Math.max(0, rateLimitExpiry - Date.now()),
    );
    return () => clearTimeout(timeoutId);
  }, [dispatch, isRateLimited, rateLimitExpiry]);

  if (!isRateLimited) return null;

  return (
    <div className='wp-rate-limit-overlay' data-test-id='wp-rate-limit-overlay' role='status' aria-live='polite'>
      <div className='wp-rate-limit-overlay-content'>
        <CircularLoader />
        <WPHeading align='center' text={t("rateLimitMessage")} fontNoto />
      </div>
    </div>
  );
};
